"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EngageActionPerformer = void 0;
const EngageLogger_1 = require("./EngageLogger");
const EngageStats_1 = require("./EngageStats");
const track_1 = require("./track");
const isDestinationActionService_1 = require("./isDestinationActionService");
const ResponseError_1 = require("./ResponseError");
const IntegrationErrorWrapper_1 = require("./IntegrationErrorWrapper");
const truncate_1 = __importDefault(require("lodash/truncate"));
class EngageActionPerformer {
    constructor(requestClient, executeInput) {
        this.requestClient = requestClient;
        this.executeInput = executeInput;
        this.logger = new EngageLogger_1.EngageLogger(this);
        this.statsClient = new EngageStats_1.EngageStats(this);
        this.dataFeedCache = this.executeInput.dataFeedCache;
        this.payload = executeInput.payload;
        this.settings = executeInput.settings;
    }
    async perform() {
        await this.beforePerform?.();
        return this.doPerform();
    }
    async request(url, options) {
        const op = this.currentOperation;
        op?.onFinally.push(() => {
            const respError = op?.error;
            if (respError) {
                const errorDetails = ResponseError_1.getErrorDetails(respError);
                const msgLowercare = errorDetails?.message?.toLowerCase();
                const isTimeoutError = msgLowercare?.includes('timeout') ||
                    msgLowercare?.includes('timedout') ||
                    msgLowercare?.includes('exceeded the deadline') ||
                    errorDetails.code?.toLowerCase().includes('etimedout');
                if (isTimeoutError) {
                    const status = errorDetails.status ?? respError.status ?? 408;
                    respError.status = status;
                    errorDetails.status = status;
                    const errorCode = errorDetails.code ?? respError.code ?? 'etimedout';
                    respError.code = errorCode;
                    errorDetails.code = errorCode;
                    respError.retry = true;
                }
                if (errorDetails.code)
                    op.tags.push(`response_code:${errorDetails.code}`);
                if (errorDetails.status)
                    op.tags.push(`response_status:${errorDetails.status}`);
                if (this.onResponse)
                    try {
                        this.onResponse({ error: respError, operation: op });
                    }
                    catch (e) {
                        op.logs.push(`Error in onResponse: ${e}`);
                    }
            }
            else {
                const resp = op?.result;
                if (resp && resp.status)
                    op.tags.push(`response_status:${resp.status}`);
                if (this.onResponse)
                    try {
                        this.onResponse({ response: resp, operation: op });
                    }
                    catch (e) {
                        op.logs.push(`Error in onResponse: ${e}`);
                    }
            }
        });
        return await this.requestClient(url, options);
    }
    redactPii(pii) {
        if (!pii) {
            return pii;
        }
        if (pii.length <= 8) {
            return '***';
        }
        return pii.substring(0, 3) + '***' + pii.substring(pii.length - 3);
    }
    isFeatureActive(featureName, getDefault) {
        if (isDestinationActionService_1.isDestinationActionService())
            return true;
        if (!this.executeInput.features || !(featureName in this.executeInput.features))
            return getDefault?.();
        return this.executeInput.features[featureName];
    }
    logInfo(msg, metadata) {
        this.logger.logInfo(msg, metadata);
    }
    logError(msg, metadata) {
        this.logger.logError(msg, metadata);
    }
    logOnError(logMessage) {
        const op = this.currentOperation;
        op?.onFinally.push(() => {
            if (op.error) {
                const msg = typeof logMessage === 'function' ? logMessage(op) : logMessage;
                op.logs.push(msg);
            }
        });
    }
    statsIncr(metric, value, tags) {
        this.statsClient.stats({ method: 'incr', metric, value, tags });
    }
    statsHistogram(metric, value, tags) {
        this.statsClient.stats({ method: 'histogram', metric, value, tags });
    }
    statsSet(metric, value, tags) {
        this.statsClient.stats({ method: 'set', metric, value, tags });
    }
    get logDetails() {
        return this.logger.logDetails;
    }
    get tags() {
        return this.statsClient.tags;
    }
    rethrowIntegrationError(error, getWrapper) {
        throw IntegrationErrorWrapper_1.IntegrationErrorWrapper.wrap(error, getWrapper, this.currentOperation);
    }
}
__decorate([
    track_1.track()
], EngageActionPerformer.prototype, "perform", null);
__decorate([
    track_1.track({
        onTry: addUrlToLog,
        onFinally: addUrlToLog
    })
], EngageActionPerformer.prototype, "request", null);
exports.EngageActionPerformer = EngageActionPerformer;
function addUrlToLog(ctx) {
    const ctxFull = ctx;
    const argUrl = ctx.funcArgs?.[0];
    if (ctxFull.logs && argUrl) {
        ctxFull.logs.push(truncate_1.default(argUrl, { length: 70 }));
    }
}
//# sourceMappingURL=EngageActionPerformer.js.map